import { InjectionToken } from '@angular/core';

export interface ISettingsPage<T = any> {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly icon?: string;

  readonly component: any;

  initialData: T;
}

export const KFM_SETTINGS_PAGE = new InjectionToken<ISettingsPage>(
  'KFM_SETTINGS_PAGE',
);
